import { referralsCount } from '../entity/selector';

import { useReferralMany } from './query';

export const useReferralsCount = () => {
  const { data: count } = useReferralMany({
    select: referralsCount,
  });

  return count;
};
